"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformVideoInput = exports.transformVideoDevice = exports.stopTransformationAndGetIntrinsicDevice = exports.resetTransformedVideoInput = exports.isBrowserSupported = exports.getVideoFxConfig = void 0;
var _amazonChimeSdkJs = require("amazon-chime-sdk-js");
var _reactDeviceDetect = require("react-device-detect");
var _StudioLogger = require("@studio/logger/StudioLogger");
var _VirtualBackground = require("@studio/constants/VirtualBackground");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var logger = new _StudioLogger.StudioLogger('transformVideoDevice');
var blurUtilsLogger = new _StudioLogger.StudioLogger('blurUtils');
// creating it here as it is required to be passed to blur utility methods at chime's end
var chimeLogger = new _amazonChimeSdkJs.ConsoleLogger('chimeBlurLogger', _amazonChimeSdkJs.LogLevel.INFO);

/*
      Defines the videoConfig settings
        1. backgroundBlur.isEnabled: Blur background is enabled if true
        2. backgroundBlur.strength: strength of blur background. Three possible values are 'low' | 'medium' | 'high'
      The following settings are not related to blur functionality and they are related to background replacement but
      it's a required value for this object so passed some dummy values
        1. backgroundReplacement.isEnabled: Background replacement is enabled if true
        2. backgroundReplacement.backgroundImageURL: Image url to be used for background replacement
        3. backgroundReplacement.defaultColor: Default color for background replacement
       */
var videoFxConfig = {
  backgroundBlur: {
    isEnabled: true,
    strength: 'high'
  },
  backgroundReplacement: {
    isEnabled: false,
    backgroundImageURL: 'notdefined.jpg',
    defaultColor: undefined
  }
};

/**
 * Checks if a browser & version is supported for blur background feature
 * @return {Promise<boolean>}
 */
var isBrowserSupported = exports.isBrowserSupported = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return _amazonChimeSdkJs.VideoFxProcessor.isSupported(chimeLogger, false);
        case 1:
          return _context.a(2, _context.v);
      }
    }, _callee);
  }));
  return function isBrowserSupported() {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Checks if the browser supports blur background feature
 * @returns {Promise<boolean>}
 */
var checkBrowserSupport = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var isSupported;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return isBrowserSupported();
        case 1:
          isSupported = _context2.v;
          if (isSupported) {
            _context2.n = 2;
            break;
          }
          throw new Error("Background blur is not supported for browser ".concat(_reactDeviceDetect.browserName, " version ").concat(_reactDeviceDetect.browserVersion));
        case 2:
          return _context2.a(2, isSupported);
      }
    }, _callee2);
  }));
  return function checkBrowserSupport() {
    return _ref2.apply(this, arguments);
  };
}();

/**
 *
 * @param filterType
 * @param backgroundImageURL
 * @returns {{backgroundReplacement: {defaultColor: string, isEnabled: boolean, backgroundImageURL: string}, backgroundBlur: {strength: string, isEnabled: boolean}}}
 */
var getVideoFxConfig = exports.getVideoFxConfig = function getVideoFxConfig(filterType) {
  var backgroundImageURL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return {
    backgroundBlur: {
      isEnabled: filterType === _VirtualBackground.BACKGROUND_OPTIONS.BLUR,
      strength: 'high'
    },
    backgroundReplacement: {
      isEnabled: filterType === _VirtualBackground.BACKGROUND_OPTIONS.CUSTOM,
      backgroundImageURL: backgroundImageURL,
      defaultColor: backgroundImageURL ? undefined : '#5C617C'
    }
  };
};

/**
 * Transforms the video input
 * @param videoInputDevice
 * @param videoFxConfig
 * @returns {Promise<DefaultVideoTransformDevice>}
 */
var transformVideoInput = exports.transformVideoInput = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(videoInputDevice, videoFxConfig) {
    var vfxProcessor, transformedVideoDevice;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return checkBrowserSupport();
        case 1:
          _context3.n = 2;
          return _setupProcessor(videoFxConfig);
        case 2:
          vfxProcessor = _context3.v;
          transformedVideoDevice = new _amazonChimeSdkJs.DefaultVideoTransformDevice(chimeLogger, videoInputDevice, [vfxProcessor]); // we need to set this to 30 or else it will default to 15 fps
          transformedVideoDevice.framerate = 30;
          logger.info('Video Input transform successful', {
            videoFxConfig: videoFxConfig,
            videoInputDevice: videoInputDevice
          });
          return _context3.a(2, transformedVideoDevice);
      }
    }, _callee3);
  }));
  return function transformVideoInput(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Resets the view input
 * @param transformedVideoDevice
 * @returns {Promise<*>}
 */
var resetTransformedVideoInput = exports.resetTransformedVideoInput = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(transformedVideoDevice) {
    var intrinsicDevice;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _context4.n = 1;
          return transformedVideoDevice.intrinsicDevice();
        case 1:
          intrinsicDevice = _context4.v;
          _context4.n = 2;
          return transformedVideoDevice.stop();
        case 2:
          logger.info('Video Input transform reset successful.', {
            intrinsicDevice: intrinsicDevice
          });
          return _context4.a(2, intrinsicDevice);
      }
    }, _callee4);
  }));
  return function resetTransformedVideoInput(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * Setup the processor to apply video filters to the chime video
 * @param videoFxConfig Configuration settings
 * @return {Promise<VideoFxProcessor>} The processor object
 */
var _setupProcessor = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(videoFxConfig) {
    var retry,
      _args5 = arguments,
      _t;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          retry = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : true;
          _context5.p = 1;
          _context5.n = 2;
          return _amazonChimeSdkJs.VideoFxProcessor.create(chimeLogger, videoFxConfig);
        case 2:
          return _context5.a(2, _context5.v);
        case 3:
          _context5.p = 3;
          _t = _context5.v;
          if (!retry) {
            _context5.n = 5;
            break;
          }
          blurUtilsLogger.info("setupProcessor - Error creating VideoFxProcessor. Retrying Once. Error: ".concat(_t), {});
          _context5.n = 4;
          return _setupProcessor(videoFxConfig, false);
        case 4:
          _context5.n = 6;
          break;
        case 5:
          blurUtilsLogger.error("setupProcessor - Error creating VideoFxProcessor. Not retrying. Error: ".concat(_t), {});
          throw new Error('Error creating VideoFxProcessor');
        case 6:
          return _context5.a(2);
      }
    }, _callee5, null, [[1, 3]]);
  }));
  return function setupProcessor(_x4) {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * @deprecated - use transformVideoInput instead - To be removed here - WEBINAR-37005
 * Transforms the video on the basis of video input device
 * @param videoInputDevice Device id of the video input device
 * @return {Promise<VideoTransformDevice>} The transformed device
 */
var transformVideoDevice = exports.transformVideoDevice = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(videoInputDevice) {
    var transformDevice, vfxProcessor, _t2;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.p = _context6.n) {
        case 0:
          // Declare a transform device object
          transformDevice = null;
          _context6.p = 1;
          _context6.n = 2;
          return isBrowserSupported();
        case 2:
          if (_context6.v) {
            _context6.n = 3;
            break;
          }
          blurUtilsLogger.info("Background blur is not supported for browser ".concat(_reactDeviceDetect.browserName, " version ").concat(_reactDeviceDetect.browserVersion), '');
          _context6.n = 5;
          break;
        case 3:
          _context6.n = 4;
          return _setupProcessor(videoFxConfig);
        case 4:
          vfxProcessor = _context6.v;
          transformDevice = new _amazonChimeSdkJs.DefaultVideoTransformDevice(chimeLogger, videoInputDevice, [vfxProcessor]);
        case 5:
          _context6.n = 7;
          break;
        case 6:
          _context6.p = 6;
          _t2 = _context6.v;
          blurUtilsLogger.error('An error occurred while starting blur background process in transformVideoDevice', _t2);
        case 7:
          return _context6.a(2, transformDevice);
      }
    }, _callee6, null, [[1, 6]]);
  }));
  return function transformVideoDevice(_x5) {
    return _ref6.apply(this, arguments);
  };
}();

/**
 * @deprecated - use resetTransformedVideoInput instead - To be removed here - WEBINAR-37005
 * This function is used to gracefully stop the Vfx transformation stream to release all the resources on user's system
 * @param transformedVideoDevice The transformed device
 * @return Intrinsic device
 */
var stopTransformationAndGetIntrinsicDevice = exports.stopTransformationAndGetIntrinsicDevice = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(transformedVideoDevice) {
    var intrinsicDevice, _t3;
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.p = _context7.n) {
        case 0:
          // Intrinsic device is the base video device on which the video transformation is applied. So it's a plain root device
          // which doesn't have vfx effects applied upon.
          intrinsicDevice = null;
          _context7.p = 1;
          if (!transformedVideoDevice) {
            _context7.n = 4;
            break;
          }
          _context7.n = 2;
          return transformedVideoDevice.intrinsicDevice();
        case 2:
          intrinsicDevice = _context7.v;
          _context7.n = 3;
          return transformedVideoDevice.stop();
        case 3:
          _context7.n = 5;
          break;
        case 4:
          blurUtilsLogger.error('unable to stop transformation stream since video device is not found', '');
        case 5:
          _context7.n = 7;
          break;
        case 6:
          _context7.p = 6;
          _t3 = _context7.v;
          blurUtilsLogger.error('An error occurred while stopping blur background process in transformVideoDevice', _t3);
        case 7:
          return _context7.a(2, intrinsicDevice);
      }
    }, _callee7, null, [[1, 6]]);
  }));
  return function stopTransformationAndGetIntrinsicDevice(_x6) {
    return _ref7.apply(this, arguments);
  };
}();